import {
  getDocs,
  query,
  collectionGroup,
  where,
  getDoc,
  orderBy,
} from "firebase/firestore";
import "../style.css";
import React, { useEffect, useState } from "react";
import { db } from "../firebase-config";
import parse from "html-react-parser";
import { UserAuth } from "../context/authContext";
import PostsSection from "../components/post";
import moment from "moment";
import Nav from "../components/navbar";
import Toptitle from "../components/pagetop";
import empty from "../assets/empty.json";
import Lottie from "lottie-react";
import { motion } from "framer-motion";

export default function Category() {
  const { user } = UserAuth();

  const getURL = () => {
    const currentURL = window.location.pathname;
    const formatURL = currentURL.replace("/explore/", "");
    const formattedURL = formatURL.replace("%20", " ");

    return formattedURL;
  };

  const [posts, setPosts] = useState([]);
  const [users, setUsers] = useState([]);
  const [loader, setLoader] = useState(true);

  const getPosts = async () => {
    const postsQuery = query(
      collectionGroup(db, "Posts"),
      where("category", "==", getURL()),
      orderBy("datePublished", "desc")
    );

    const querySnapshot = await getDocs(postsQuery);
    let tempPosts = [];

    const userparentPromises = [];
    querySnapshot.forEach((post) => {
      const postRef = post.ref;
      const postRefParent = postRef.parent;
      const postRefParent_ParentDoc = postRefParent.parent;
      const postCategoriesColRef = postRefParent_ParentDoc.parent;
      const postCategoriesColRef_userDocRef = postCategoriesColRef.parent;

      userparentPromises.push(getDoc(postCategoriesColRef_userDocRef));

      tempPosts.push({
        id: post.id,
        data: post.data(),
      });
    });
    setPosts(tempPosts);

    const arrayofParentUserDoc = await Promise.all(userparentPromises);
    setUsers(arrayofParentUserDoc);
    setLoader(false);
    console.log(posts);
  };
  useEffect(() => {
    getPosts();
  }, []);

  return (
    <div className="mainWrapper">
      <Nav />
      <div className="innerwrapper overflow-y-auto p-0">
        <Toptitle title={getURL()} />
        {posts.length > 0 ? (
          <div className="mt-2 min-h-[32rem] px-7 w-full flex flex-col gap-7 justify-center items-center">
            {loader === false &&
              posts.map((post, index) => {
                return (
                  <PostsSection
                    key={index}
                    publishedBy={users[index].data().username}
                    datePublished={
                      post.data.datePublished &&
                      moment(post.data.datePublished.toDate()).calendar()
                    }
                    profilePic={users[index].data().profilePic}
                    title={post.data.title}
                    content={post.data.content && parse(post.data.content)}
                    tumbnailURL={post.data.tumbnailURL && post.data.tumbnailURL}
                    pdfName={post.data.pdfName && post.data.pdfName}
                    pdfURL={post.data.pdfURL && post.data.pdfURL}
                    instaURL={users[index].data().instaURL}
                    twitterURL={users[index].data().twitterURL}
                    linkedinURL={users[index].data().linkedin}
                    githubURL={users[index].data().githubURL}
                    about={users[index].data().bio}
                    occupation={users[index].data().occupation}
                    postId={post.id}
                    publishedId={post.data.publishedBy}
                    caption={post.data.caption}
                    postCategory={post.data.category}
                  />
                );
              })}
          </div>
        ) : (
          <div className="relative font-semibold mt-2 h-[32rem] pb-10 flex flex-col items-center justify-center text-zinc-500">
            <Lottie
              animationData={empty}
              loop={true}
              style={{ width: "35%" }}
            />
            <div className="absolute left-1/2 -translate-x-1/2 bottom-32 text-zinc-500 font-semibold">
              There aren't any posts in this category yet!
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
